import { render, staticRenderFns } from "./BDXNewTPAForm.vue?vue&type=template&id=5ed99d55"
import script from "./BDXNewTPAForm.vue?vue&type=script&lang=js"
export * from "./BDXNewTPAForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports